const CROSSFADE_DURATION_MS = 150;
const containerCls = "gfxciigt9k";
const contentCls = "gfxc4ppgy1";
const imgCls = "gfxi62k2s1";
const preloaderCls = "gfxplr8c46";
const errorMessageCls = "gfxe1dwdjfz";
const errorText = "gfxeb7wzeb";
const publisherLogo = "gfxp17wad8q";

export { CROSSFADE_DURATION_MS, containerCls, contentCls, errorMessageCls, errorText, imgCls, preloaderCls, publisherLogo };
import "./image.style.linaria.module.css";
//# sourceMappingURL=image.style.js.map
